import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetConsolidatedActivitiesByStudentUseCaseInterface } from 'domain/usecases';

export class RemoteGetConsolidatedActivitiesByStudent
  implements GetConsolidatedActivitiesByStudentUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetConsolidatedActivitiesByStudentUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetConsolidatedActivitiesByStudentUseCaseInterface.Params,
  ): Promise<GetConsolidatedActivitiesByStudentUseCaseInterface.Result> {
    const { type, period, validation, ...restParams } = params;

    const splittedPeriod = period.split('-');
    const requestUrl = `${this.url}/${type}/${splittedPeriod[0]}/${splittedPeriod[1]}`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, {
        ...restParams,
        validation: validation && Number(validation),
        activityStatus: '3', // Realizadas ou Finalizadas
      } as any),
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
